import { Spinner } from '../Kit/_index';
import { useLanguage } from '../../../Hooks/Contexts/Translate/useLanguageContext';

const BLOCK = 'LStudio__app_screen';

/*
    🔥 CARGA DE PANTALLA

    ⚠️ EL RETRASO NO ES UN CAPRICHO

    Si la respuesta llega en 80 ms, mostrar y esconder un spinner
    produce un parpadeo que se siente MÁS lento que no mostrar nada.
    Con delay el spinner aparece recién pasados los 300 ms, o sea solo
    cuando la espera es real.

    Poner el retraso en CSS y no en un setTimeout evita re-renderizar
    de más y que el componente tenga que limpiar un timer al
    desmontarse.

    Para el fallback de <Suspense> usá isFullScreen; para un bloque
    dentro de una vista, dejalo en false.
*/

export const PageLoader = ({
    label = null,
    size = 48,
    isFullScreen = false,
    hasDelay = true,
}) => {

    const { useDataLanguage } = useLanguage();

    const COMMON = useDataLanguage.translations?.TEMPLATES?.common ?? {};

    return (
        <div
            className={`${BLOCK}__loader`}
            data-fullscreen={isFullScreen}
            data-delay={hasDelay}
            role="status"
            aria-live="polite"
        >

            <Spinner size={size} label={label ?? COMMON.loading} />

        </div>
    );
};
